(function () {
  function handler(e) {
    console.log('click handler')
    const a = e.target.closest('a[data-lifestyle-tile="1"]');
    if (!a) return;
console.log('a', a)
    const payload = {
      collection_handle: a.dataset.collectionHandle || null,
      tile_position: Number(a.dataset.tilePosition || 0) || null,
      tile_heading: a.dataset.tileHeading || null,
      link_type: a.dataset.linkType || null,
      link_handle: a.dataset.linkHandle || null,
      href: a.getAttribute("href") || null
    };

    // Shopify Customer Events / Pixels custom event bus
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      window.Shopify.analytics.publish("custom:lifestyle_tile_click", payload);
    } else if (window.Shopify && window.Shopify.customerEvents && typeof window.Shopify.customerEvents.publish === "function") {
      // Some setups expose customerEvents instead
      window.Shopify.customerEvents.publish("custom:lifestyle_tile_click", payload);
    }

    // Do not prevent navigation; event is published synchronously.
  }

  document.addEventListener("click", handler, { capture: true });
})();
